import NodeAddIcon from '@mui/icons-material/NoteAdd'
import { darken } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useHistory } from 'react-router-dom'
import { MotionFab } from '@components'
import { colors } from '@global/constants'

interface Props {
  templateId: number | string
}

const useStyles = makeStyles(() => ({
  custom: {
    '&&': {
      backgroundColor: colors.purple.main,
      '&:hover': {
        backgroundColor: darken(colors.purple.main, 0.3),
      },
    },
  },
}))

/**
 * The create submission button in the read grid header
 *
 * @param props React props
 * @param {number | string} props.templateId The id for the selected template
 * @returns
 */
export const CreateSubmission = ({ templateId }: Props) => {
  const history = useHistory()
  const classes = useStyles()

  return (
    <MotionFab
      tooltipTitle="Create submission"
      size="medium"
      onClick={handleClick}
      className={classes.custom}
    >
      <NodeAddIcon />
    </MotionFab>
  )

  function handleClick() {
    history.push(`/codes/create/${templateId}`)
  }
}
